import styled from 'styled-components/macro';
import { row_center_both } from 'src/App/Styles/styles-helpers';
import { GlobalColors } from 'src/App/Styles/Globals';

export const FooterContain = styled.div`
	${row_center_both}
	padding: 1em;
	background: ${GlobalColors.darkPurlpe};
	font-size: 0.75em;
`;
export const FooterTitle = styled.p`
	text-align: center;
	@media (max-width: 467px) {
		display: none;
	}
`;

export const FRightContainer = styled.div`
	width: 20px;
	height: 20px;
	@media (max-width: 467px) {
		display: none;
	}
`;
